__webpack_require__.p = "/dev/848-wc-width-height/";